import { render } from "./comments-list.vue?vue&type=template&id=4678bae5"
import script from "./comments-list.vue?vue&type=script&lang=js"
export * from "./comments-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__